import { api } from './api'
import { User, LoginResponse, RegisterRequest, RegisterResponse, UpdateUserRequest } from '../types/user'
import { API_ENDPOINTS } from '../constants/api'

export const authService = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>(API_ENDPOINTS.AUTH.LOGIN, { email, password })
    api.setToken(response.access_token)
    return response
  },

  async register(userData: RegisterRequest): Promise<RegisterResponse> {
    const response = await api.post<RegisterResponse>(API_ENDPOINTS.AUTH.REGISTER, userData)
    api.setToken(response.access_token)
    return response
  },

  async getCurrentUser(token?: string): Promise<User> {
    if (token) {
      api.setToken(token)
    }
    return api.get<User>(API_ENDPOINTS.AUTH.PROFILE)
  },

  async updateUser(userId: number, userData: UpdateUserRequest): Promise<User> {
    return api.put<User>(API_ENDPOINTS.USERS.byId(userId), userData)
  },

  async changePassword(userId: number, currentPassword: string, newPassword: string): Promise<void> {
    await api.post(API_ENDPOINTS.USERS.CHANGE_PASSWORD(userId), { currentPassword, newPassword })
  },

  async logout(): Promise<void> {
    api.clearToken()
  },

  async forgotPassword(email: string): Promise<void> {
    await api.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email })
  },

  async resetPassword(token: string, newPassword: string): Promise<void> {
    await api.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, { token, newPassword })
  },
}